<template>
    <div class="goodsList spackage padding-20 bgc box-shadow">
        <div class="goods_info_box flex_box">
            <img :src="eventInfo.coveratturlid" alt="">
            <div class="goods_info">
                <p>{{eventInfo.title}}</p>
                <p>{{eventInfo.eventdesp}}</p>
                <!-- <p>华扬资本董秘培训培训华扬资本董秘培训培训华扬资本董秘培训培训华扬资本董秘培训培训华扬资本董秘培训培训华扬资本董秘培训培训 华扬资本董秘培训培训华扬资本董秘培训培训华扬资本董秘培训培训华扬资本董秘培训培训华扬资本董秘培训培训华扬资本董秘培训培训</p> -->
                <p :class="eventStatusClass(eventInfo.status)">{{eventStatusText(eventInfo.status)}}</p>
            </div>
        </div>
        <div class="select_box flex_box">
            <div class="add_goods">
                <el-button v-if="eventInfo.status !== 30" @click="addGoods()" type="primary">新增商品</el-button>
                <el-button v-if="eventInfo.status !== 30" @click="BatchImportBtn()" type="primary">批量导入</el-button>
            </div>
            <div class="goods_search flex_box">
                <div style="width: 128px;">
                    <el-select v-model="searchParams.class" placeholder="全部分类">
                        <el-option v-for="item in goodsClassList" :key="item.innerid" :label="item.name" :value="item.innerid"></el-option>
                    </el-select>
                </div>
                <div style="width: 128px;">
                    <el-select v-model="searchParams.status" class="select item" placeholder="全部状态">
                        <el-option v-for="item in goodsStatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
                <div style="width: 220px;">
                    <el-input v-model="searchParams.name" placeholder="请输入商品名称" class="input item"></el-input>
                </div>
                <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
            </div>
        </div>
        <div class="goods_table_box">
            <el-table :data="goodsListData" style="width: 100%">
                <el-table-column label="商品名称" align='left' width="300">
                    <template slot-scope="scope">
                        <div class="goods_row_box flex_box">
                            <img :src="scope.row.coveratturlid" alt="">
                            <div class="flex_box">
                                <p>{{scope.row.productname}}</p>
                                <p>{{scope.row.saleprice}}</p>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="catename" label="分类名称" align='center'></el-table-column>
                <el-table-column prop="totalcount" label="总库存" align='center'></el-table-column>
                <el-table-column prop="currenttotalcount" label="当前库存" align='center'></el-table-column>
                <el-table-column prop="limitcountbyorder" label="每单限购量" align='center'></el-table-column>
                <el-table-column prop="currentsalecount" label="已购量" align='center'></el-table-column>
                <el-table-column label="状态" align='center'>
                    <template slot-scope="scope">
                        <span :class="statusClass(scope.row.status)">{{statusText(scope.row.status)}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align='right'>
                    <template slot-scope="scope">
                        <div v-if="eventInfo.status !== 30" class="operation_box">
                            <span v-if="scope.row.status === 10 || scope.row.status === 11" @click="addGoods(scope.row)">编辑</span>
                            <span v-if="scope.row.status === 10 || scope.row.status === 11">&nbsp;|&nbsp;</span>
                            <span v-if="scope.row.status === 10 || scope.row.status === 11" @click="discontGoods(scope.row)">{{scope.row.status === 10 ? '停售' : '恢复'}}</span>
                            <span v-if="scope.row.status === 20" @click="addGoods(scope.row)">详情</span>
                        </div>
                        <div v-if="eventInfo.status === 30" class="operation_box">
                            <span @click="addGoods(scope.row)">详情</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <page :total="total" ref="page" @getList="searchBtn"></page>
        </div>
        <div class="import_goods_pop">
            <BatchImport @getGoodsList="getGoodsList" ref="BatchImportPop"></BatchImport>
        </div>
    </div>
</template>

<script>
import {getSimpleEventDetail, getMaterialCategory, getEventProductList, updateProductByStatus} from 'api/cPurchaseApi'
import Page from 'base/page/page'
import BatchImport from 'views/communityPurchase/managementOfPurchaseAndPurchase/components/BatchImport'
import {initPage} from 'common/js/mixin'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'GoodsList',
    mixins: [initPage],
    data() {
        return {
            eventInfo: {},
            total: 0,
            goodsClassList: [{innerid: 0, name: '全部分类'}],
            goodsStatusList: [{value: 0, label: '全部状态'}, {value: 10, label: '售卖中'}, {value: 11, label: '停售中'}, {value: 20, label: '售完'}],
            searchParams: {
                class: '',
                status: '',
                name: ''
            },
            goodsListData: []
        }
    },
    mounted() {
        this.findEvent()
        this.getGoodsList()
        this.getGoodsClass()
    },
    methods: {
        // 批量导入素材库商品
        BatchImportBtn() {
            this.$refs.BatchImportPop.openDialog()
        },
        // 查询单个活动详情
        findEvent() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid
            }
            getSimpleEventDetail({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.eventInfo = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 获取商品列表
        getGoodsList() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid
            }
            getEventProductList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.goodsListData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 分页及搜索
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        searchBtn() {
            // console.log(this.searchParams)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                catecode: this.searchParams.class === 0 ? '' : this.searchParams.class,
                status: this.searchParams.status === 0 ? '' : this.searchParams.status,
                productname: this.searchParams.name
            }
            // console.log(params)
            this.setLoading(true)
            getEventProductList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.goodsListData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 获取商品分类列表
        getGoodsClass() {
            this.setLoading(true)
            getMaterialCategory({
                success: data => {
                    this.setLoading(false)
                    this.goodsClassList = this.goodsClassList.concat(data.data)
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 停售、恢复商品
        discontGoods(val) {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                innerid: val.innerid,
                status: val.status === 10 ? '11' : '10'
            }
            updateProductByStatus({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.getGoodsList()
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 新增、编辑商品
        addGoods(val) {
            if (val) {
                if (val.status === 20 || this.eventInfo.status === 30) {
                    this.$router.push({name: 'AddGoods', query: {eventinnerid: this.$route.query.eventinnerid, innerid: val.innerid, edit: 0}})
                } else {
                    this.$router.push({name: 'AddGoods', query: {eventinnerid: this.$route.query.eventinnerid, innerid: val.innerid, status: this.eventInfo.status}})
                }
            } else {
                this.$router.push({name: 'AddGoods', query: {eventinnerid: this.$route.query.eventinnerid}})
            }
        },
        statusClass(value) {
            if (value === 10) {
                return 'smz'
            } else if (value === 11) {
                return 'tsz'
            } else if (value === 20) {
                return 'sw'
            }
        },
        statusText(value) {
            if (value === 10) {
                return '售卖中'
            } else if (value === 11) {
                return '停售中'
            } else if (value === 20) {
                return '售完'
            }
        },
        eventStatusText(value) {
            if (value === 0) {
                return '未开始'
            } else if (value === 10) {
                return '进行中'
            } else if (value === 11) {
                return '暂停中'
            } else if (value === 30) {
                return '已结束'
            }
        },
        eventStatusClass(value) {
            if (value === 0) {
                return 'wks'
            } else if (value === 10) {
                return 'jxz'
            } else if (value === 11) {
                return 'ztz'
            } else if (value === 30) {
                return 'yjs'
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page,
        BatchImport
    }
}
</script>

<style lang="scss" type="text/scss">
    .goodsList{
        .flex_box{
            display: flex;
        }
        .wks {
            color: #F56C6C;
        }
        .jxz {
            color: #67C23A;
        }
        .ztz {
            color: #E6A23C;
        }
        .yjs {
            color: #606266;
        }
        .goods_info_box{
            overflow: hidden;
            padding: 22px 20px;
            background-color: #FAFAFA;
            img{
                min-width: 180px;
                width: 180px;
                height: 102px;
            }
            .goods_info{
                margin-left: 30px;
                p{
                    margin-bottom: 10px;
                }
                p:nth-of-type(1){
                    color: #303133;
                    font-size:16px;
                    font-family:PingFangSC-Medium,PingFangSC;
                    font-weight: bold;
                    line-height:22px;
                }
                p:nth-of-type(2){
                    color: #606266;
                    font-size:15px;
                    line-height:21px;
                    width: 900px;
                    // background-color: pink;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                p:nth-of-type(3){
                    // color: #67C23A;
                    font-size:14px;
                    font-family:PingFangSC-Regular,PingFangSC;
                    line-height:20px;
                    margin-bottom: 0;
                }
            }
        }
        .select_box{
            margin: 30px 0;
            justify-content: space-between;
            .add_goods{
                .el-button{
                    width: 110px;
                }
            }
            .goods_search{
                .el-input__icon {
                    line-height: 2px;
                }
                &>div{
                    margin-right: 30px;
                }
            }
        }
        .goods_table_box{
            .el-table__empty-block {
                min-height: 500px;
            }
            .el-table th>.cell {
                font-weight: bold!important;
                white-space: nowrap;
                font-size: 16px;
            }
            .goods_row_box{
                img{
                    width: 60px;
                    height: 60px;
                    margin-right: 16px;
                }
                &>div{
                    flex-direction: column;
                    justify-content: space-between;
                    p{
                        text-align: left;
                        color: #303133;
                        line-height:18px;
                    }
                    p:nth-of-type(2){
                        color: #F56C6C;
                    }
                }
            }
            .operation_box{
                white-space: nowrap;
                span{
                    color: #409EFF;
                    cursor: pointer;
                }
            }
            .smz {
                color: #67C23A;
            }
            .tsz {
                color: #E6A23C;
            }
            .sw {
                color: #F56C6C;
            }
        }
        .import_goods_pop{
            .el-dialog__wrapper {
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: left;
            }
            .el-dialog {
                width: 800px;
                // height: 600px;
                margin: 0!important;
            }
            .el-dialog .el-dialog__body {
                padding: 0px!important;
                height: 100%;
            }
        }
    }
</style>